module.exports = __webpack_public_path__ + "static/BG_Senjata-34c61b3774dbfd2fb5403b5f044f739d.jpg";